import React from 'react'
import clsx from 'clsx'
import { photoBgColor } from '@ow/utils'

const Photo = function ({ src, name, userId }) {
  const renderName = (v) => {
    return v && v.length > 1 ? v[v.length - 1] : v
  }
  const renderPhoto = () => {
    if (src) {
      return <img src={src} alt="" className="w-8 h-8 rounded-full mr-1" />
    }
    return (
      <div
        className={clsx(
          'text-white w-6 h-6 rounded-full mr-1  flex items-center justify-center'
        )}
        style={{
          border: '0.0625rem solid #fff',
          boxShadow: '0 0 0.5rem 0 rgba(0,0,0,0.12)',
          background: photoBgColor(userId),
        }}
      >
        <span style={{ opacity: '0.8' }}>{renderName(name)}</span>
      </div>
    )
  }
  return renderPhoto()
}
export default Photo
